import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-session-modal',
  standalone: true,
  imports: [DialogModule, NgClass],
  templateUrl: './session-modal.component.html',
})
export class SessionModalComponent{
  @Input() countdown = 0;
  @Input() visible = false;
  @Output() stayActive = new EventEmitter<void>();
}
